
import { computed, defineComponent } from 'vue';
import { useRoute } from 'vue-router';
import { useDriveStore } from '@/modules/drive/store/driveStore';
import { useMainStore } from '@/store/mainStore';
import DriveSharedBar from '@/modules/drive/components/DriveSharedBar.vue';
import { NAVIGATION_PAGES } from '@/types/enums';

export default defineComponent({
  components: { DriveSharedBar },
  emits: ['on-click-back', 'on-click-share', 'on-click-dots'],
  setup() {
    const driveStore = useDriveStore();
    const mainStore = useMainStore();
    const route = useRoute();

    const isNetwork = computed(() => route.meta.isNetwork || false);
    const isMy = computed(() => driveStore.fullscreenPhoto?.owner?.accountId === mainStore.user.accountId);

    const navigationPage = computed(() => route.meta.navigationPage);
    const isCase = computed(
      () => navigationPage.value === NAVIGATION_PAGES.DRIVE_CASES
        || navigationPage.value === NAVIGATION_PAGES.CASE_EDIT
        || navigationPage.value === NAVIGATION_PAGES.CASE_VIEW,
    );
    return {
      isNetwork,
      isMy,
      isCase,
    };
  },
});
